import axios from "../api/api"
import { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";

const GETDATABYID = "/api/story"

const StoryModal = ({ show, setShow, id, setId }) => {
    const [content, Setcontent] = useState([])

    useEffect(() => {
        const getdatabyid = async () => {
            if (show === true) {
                const response = await axios.get(`${GETDATABYID}/${id}`)
                const data = response.data
                Setcontent(data)
            } else {
                Setcontent([])
            }
        }
        getdatabyid()
    }, [id])

    // Handle hide
    const handleHide = () => {
        setId(null);
        setShow(false);
    }



    return (
        <Modal show={show} onHide={handleHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Story Details -{content?.hindititle}   </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {
                    content?.status === "published" ? <strong className="text-capitalize text-green">{content?.status}  </strong> : <strong className="text-capitalize text-red">{content?.status} on {content?.scheduledate} </strong>  
                }
                <Table bordered striped hover>
                    <tbody>
                        <tr>
                            <th className="w-25">English Title</th>
                            <td>{content?.englishtitle}</td>
                        </tr>
                        <tr>
                            <th className="w-25">Hinglish Title</th>
                            <td>{content?.hinglishtitle}</td>
                        </tr>
                        <tr>
                            <th className="w-25">Hindi Content</th>
                            <td>{content?.hindicontent}</td>
                        </tr>
                        <tr>
                        <th className="w-25">English Content</th>
                            <td>{content?.englishcontent}</td>
                        </tr>
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    )
}

export default StoryModal;